
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("fOasY", function(module, exports) {

$parcel$export(module.exports, "PopupViewWithAISnippet", () => $9c44b8c40f625697$export$28f0f82c7dd8d86e);
/* PopupViewWithAISnippet.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $i5WUp = parcelRequire("i5WUp");

var $9wGTI = parcelRequire("9wGTI");

var $71GjD = parcelRequire("71GjD");

var $gz8ZY = parcelRequire("gz8ZY");

var $bQm3c = parcelRequire("bQm3c");

var $AXitC = parcelRequire("AXitC");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $4vzBZ = parcelRequire("4vzBZ");

var $fpGTa = parcelRequire("fpGTa");
var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $ly2zj = parcelRequire("ly2zj");

var $AXitC = parcelRequire("AXitC");
const $6b006f2611e1e03b$var$SNIPPET_ENTRYPOINT_ID = '55dba3ae-58fa-41e0-828b-1e30fe66c0ba';
const $6b006f2611e1e03b$var$TROUBLE_SHOOTING_URL = 'https://support.atlassian.com/organization-administration/docs/troubleshooting-for-atlassian-intelligence/';
const $6b006f2611e1e03b$var$i18n = (0, $2nPZH.defineMessages)({
    noAIResultFooterText: {
        id: "page-card.popup-view-with-ai-snippet.no-ai-footer-text",
        defaultMessage: "Why am I seeing this?"
    }
});
const $6b006f2611e1e03b$var$noAIFooterWrapperStyles = (0, $ecnYn.xcss)({
    borderTopWidth: 'border.width',
    borderTopStyle: 'solid',
    borderTopColor: 'color.border',
    paddingBlock: 'space.100',
    paddingInline: 'space.200',
    font: 'font.body.small'
});
const $6b006f2611e1e03b$var$linkStyles = (0, $ecnYn.xcss)({
    zIndex: 'navigation',
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    textDecoration: 'none',
    ':hover': {
        color: 'color.text.subtlest',
        cursor: 'pointer'
    },
    ':visited': {
        color: 'color.text.subtlest',
        cursor: 'pointer'
    }
});
const $6b006f2611e1e03b$export$e3ccdece68166355 = ({ showAIFooter: showAIFooter = true })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { id: id } = (0, $gwFzn.useContext)((0, $AXitC.PageCardContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ly2zj.FeedbackCollectorPropertiesProvider), {
        entrypointId: $6b006f2611e1e03b$var$SNIPPET_ENTRYPOINT_ID
    }, showAIFooter ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ly2zj.AISummaryFooter), {
        analyticsProperties: {
            source: 'aiSnippet',
            additionalAnalyticsAttributes: {}
        },
        contentId: id
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $6b006f2611e1e03b$var$noAIFooterWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4vzBZ))), {
        label: "",
        color: "var(--ds-icon-subtle, #626F86)",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fpGTa.default), {
        xcss: $6b006f2611e1e03b$var$linkStyles,
        href: $6b006f2611e1e03b$var$TROUBLE_SHOOTING_URL,
        target: "_blank"
    }, formatMessage($6b006f2611e1e03b$var$i18n.noAIResultFooterText)))));
};


var $qaY7H = parcelRequire("qaY7H");
var $aoeyL = parcelRequire("aoeyL");/* ExcerptWithAISnippet.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $gUu2y = parcelRequire("gUu2y");

var $inPa6 = parcelRequire("inPa6");

var $fYQcF = parcelRequire("fYQcF");

var $au4KV = parcelRequire("au4KV");

var $fXbFR = parcelRequire("fXbFR");

var $AXitC = parcelRequire("AXitC");

var $4xawV = parcelRequire("4xawV");

var $gETnG = parcelRequire("gETnG");
const $1160fdf345d5525b$var$ExcerptContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_16jlcs5v _1o9zidpf _i0dl1wug _11c8dcr7 _slp31hna _19pkpxbi _kq6x1jtm",
            __cmplp.className
        ])
    });
});
const $1160fdf345d5525b$export$4fc591cd3f78da48 = ({ loading: loading, snippet: snippet, isEndOfPage: isEndOfPage = false })=>{
    const { width: width } = (0, $gwFzn.useContext)((0, $4xawV.PageCardsContext));
    const { id: contentId, excerpt: excerpt } = (0, $gwFzn.useContext)((0, $AXitC.PageCardContext));
    const { trackAIResultView: trackAIResultView } = (0, $fYQcF.useAIEventsInstrumentation)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const snippetRef = (0, $gwFzn.useRef)(null);
    const snippetValueRef = (0, $gwFzn.useRef)(snippet);
    (0, $gwFzn.useEffect)(()=>{
        snippetValueRef.current = snippet;
    }, [
        snippet
    ]);
    const { getDwellTime: getDwellTime } = (0, $fXbFR.usePopupDwellTime)(snippetRef, 250);
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            const dwellTime = getDwellTime();
            if (dwellTime > 0) createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'dwelled',
                    actionSubject: 'aiSnippetHoverCard',
                    source: isEndOfPage ? 'endOfPageRecommendations' : 'pageTree',
                    actionSubjectId: isEndOfPage ? 'endOfPageRecommendations' : 'pageTree',
                    attributes: {
                        contentId: contentId,
                        dwellTime: dwellTime,
                        snippetShown: !!snippetValueRef.current
                    }
                }
            }).fire();
            if (snippetValueRef.current && dwellTime >= 3000) trackAIResultView({
                attributes: {
                    dwellTime: dwellTime
                }
            });
        };
    // we only want to run this effect on un-mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($1160fdf345d5525b$var$ExcerptContainer, {
        key: `${contentId}-${width}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $au4KV.AIStreamLoading), {
        padding: "space.0"
    }));
    if (!snippet) {
        if (excerpt) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gETnG.Excerpt), null);
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($1160fdf345d5525b$var$ExcerptContainer, {
        key: `${contentId}-${width}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        ref: snippetRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gUu2y.default), null, snippet)));
};

/* ExcerptWithAISnippetV2.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $gUu2y = parcelRequire("gUu2y");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $inPa6 = parcelRequire("inPa6");

var $gdv5Z = parcelRequire("gdv5Z");
var $eyWa4 = parcelRequire("eyWa4");

var $7p4As = parcelRequire("7p4As");

var $fYQcF = parcelRequire("fYQcF");

var $au4KV = parcelRequire("au4KV");

var $fXbFR = parcelRequire("fXbFR");

var $AXitC = parcelRequire("AXitC");

var $4xawV = parcelRequire("4xawV");

const $858989206fd37bb9$var$i18n = (0, $2nPZH.defineMessages)({
    seeMore: {
        id: "page-card.popup-view-with-ai-snippet.see-more",
        defaultMessage: "See more"
    }
});
const $858989206fd37bb9$var$styles = {
    container: "_16jlcs5v _1o9zidpf _i0dl1wug _11c81o8v _1bsb1osq _y3gn1e5h _1i4q1hna _1tkevbgk _kq6x1jtm",
    loading: "_16jlcs5v _1o9zidpf _i0dl1wug _11c81o8v _1tke16xz _1e0c1txw _4cvr1h6o _4t3i1osq _y3gncvlb _slp31hna",
    truncatedText: "_1reo15vq _18m915vq _11c81o8v _1e0ccj1k _sudp1e54 _1yyjegat _1i4q1hna _1kt9b3bt _1aa1usic _kfgtoyo4",
    fullText: "_1reo15vq _18m915vq _11c81o8v _1e0ccj1k _1i4q1hna _sudp1e54 _1yyjqfx8",
    seeMore: "_4bfu18uv _1hmsglyw _ajmmnqa1 _1yt4ze3t _593818uv _yha2glyw _1nmznqa1 _ekv61o8v _1calze3t _iijb1kw7 _bpspmoej _1700usic _tmud1hrf",
    snippet: "_1tke16xz"
};
const $858989206fd37bb9$export$42f9a5b19b42c37e = ({ loading: loading, snippet: snippet, isEndOfPage: isEndOfPage = false })=>{
    const { width: width } = (0, $gwFzn.useContext)((0, $4xawV.PageCardsContext));
    const { id: contentId, excerpt: excerpt } = (0, $gwFzn.useContext)((0, $AXitC.PageCardContext));
    const { trackAIResultView: trackAIResultView } = (0, $fYQcF.useAIEventsInstrumentation)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const snippetRef = (0, $gwFzn.useRef)(null);
    const [isExpanded, setIsExpanded] = (0, $gwFzn.useState)(false);
    const [isTruncated, setIsTruncated] = (0, $gwFzn.useState)(false);
    const content = snippet || excerpt;
    const contentValueRef = (0, $gwFzn.useRef)(content);
    (0, $gwFzn.useEffect)(()=>{
        if (!loading) {
            contentValueRef.current = content;
            if (snippetRef.current) {
                const isOverflowing = snippetRef.current.scrollHeight > snippetRef.current.offsetHeight;
                setIsTruncated(isOverflowing);
            }
        }
    }, [
        content,
        loading
    ]);
    const { getDwellTime: getDwellTime } = (0, $fXbFR.usePopupDwellTime)(snippetRef, 250);
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            const dwellTime = getDwellTime();
            if (dwellTime > 0) createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'dwelled',
                    actionSubject: 'aiSnippetHoverCard',
                    source: isEndOfPage ? 'endOfPageRecommendations' : 'pageTree',
                    actionSubjectId: isEndOfPage ? 'endOfPageRecommendations' : 'pageTree',
                    attributes: {
                        contentId: contentId,
                        dwellTime: dwellTime,
                        snippetShown: !!contentValueRef.current
                    }
                }
            }).fire();
            if (contentValueRef.current && dwellTime >= 3000) trackAIResultView({
                attributes: {
                    dwellTime: dwellTime
                }
            });
        }; // we only want to run this effect on un-mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gdv5Z.default), {
        xcss: $858989206fd37bb9$var$styles.loading,
        key: `${contentId}-${width}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $au4KV.AIStreamLoading), {
        padding: "space.0"
    }));
    if (!content) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eyWa4.default), {
        xcss: $858989206fd37bb9$var$styles.snippet,
        alignBlock: "start",
        alignInline: "start",
        grow: "fill",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gdv5Z.default), {
        xcss: $858989206fd37bb9$var$styles.container,
        key: `${contentId}-${width}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gdv5Z.default), {
        xcss: isExpanded ? $858989206fd37bb9$var$styles.fullText : $858989206fd37bb9$var$styles.truncatedText,
        ref: snippetRef,
        as: "p"
    }, isTruncated && !isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gdv5Z.default), {
        as: "span",
        xcss: $858989206fd37bb9$var$styles.seeMore
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7p4As.default), {
        appearance: "subtle",
        spacing: "compact",
        href: "#",
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            setIsExpanded(!isExpanded);
            return false;
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $858989206fd37bb9$var$i18n.seeMore))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gUu2y.default), {
        className: (0, $35pXk.default)([
            "_18s8ze3t _1yt4ze3t _11c81o8v _1e0c1ule _1bsb1osq"
        ])
    }, content))), !loading && !!snippet && !isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6b006f2611e1e03b$export$e3ccdece68166355), {
        showAIFooter: !!snippet
    }));
};


var $c9Olr = parcelRequire("c9Olr");
var $dDr80 = parcelRequire("dDr80");
var $9CEYG = parcelRequire("9CEYG");
var $8Grk3 = parcelRequire("8Grk3");
var $1R1bQ = parcelRequire("1R1bQ");
var $fROKr = parcelRequire("fROKr");
var $eSkJX = parcelRequire("eSkJX");
var $63k9q = parcelRequire("63k9q");
const $9c44b8c40f625697$var$styles = (0, $ecnYn.xcss)({
    width: '400px'
});
const $9c44b8c40f625697$var$headerStyle = (0, $ecnYn.xcss)({
    width: '100%',
    overflowWrap: 'break-word',
    wordBreak: 'break-all',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $9c44b8c40f625697$var$headerIconStyle = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    alignSelf: 'flex-start'
});
const $9c44b8c40f625697$var$titleStyles = (0, $ecnYn.xcss)({
    font: "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    overflowWrap: 'break-word',
    display: '-webkit-box',
    WebkitLineClamp: '2',
    WebkitBoxOrient: 'vertical'
});
const $9c44b8c40f625697$var$aiSnippetStyles = {
    container: "_1tke16xz _kq6x1jtm"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $9c44b8c40f625697$var$PopupCard = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1yt41xcl _1e0c1txw _2lx21bp4 _1bsb1kdj",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $9c44b8c40f625697$var$Header = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $9c44b8c40f625697$var$TitleContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_18s81f27 _11c8lodh _1reo15vq _18m915vq _1bto1l2s _1i4q1hna _1e0ccj1k _1yyjcs5v _sudp1e54",
            __cmplp.className
        ])
    });
});
const $9c44b8c40f625697$export$28f0f82c7dd8d86e = ({ shouldUseAutomationDiscovery: shouldUseAutomationDiscovery, loading: loading, snippet: snippet, isEndOfPage: isEndOfPage = false, contentId: contentId, contentType: contentType, onLoadComplete: onLoadComplete })=>{
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    if ((0, $9wGTI.fg)('p2m-hover-card-updates')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($9c44b8c40f625697$export$89baf208493bc85a, {
        shouldUseAutomationDiscovery: shouldUseAutomationDiscovery,
        loading: loading,
        snippet: snippet,
        isEndOfPage: isEndOfPage,
        contentId: contentId,
        contentType: contentType,
        onLoadComplete: onLoadComplete
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dDr80.PageCardContainer), {
        isHoverPageCard: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9CEYG.PageLink), {
        shouldHideFolder: true,
        featureAttributionCode: isEndOfPage ? (0, $71GjD.FeatureCode).EOP_REC_CARD : (0, $71GjD.FeatureCode).PAGE_TREE_CARD
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($9c44b8c40f625697$var$PopupCard, {
        "data-testid": "page-card-popup-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($9c44b8c40f625697$var$Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aoeyL.ContentIcon), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8Grk3.QuickActions), {
        actions: [
            'edit',
            'star'
        ]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($9c44b8c40f625697$var$TitleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $63k9q.Title), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), isNav4Enabled && {
        space: 'space.050'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eSkJX.Subtitle), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $c9Olr.LastAction), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1R1bQ.SocialProof), {
        isInlineAction: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fROKr.StatusLozenge), {
        isInColumn: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1160fdf345d5525b$export$4fc591cd3f78da48), {
        loading: !!loading,
        snippet: snippet,
        isEndOfPage: isEndOfPage
    })), !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6b006f2611e1e03b$export$e3ccdece68166355), {
        showAIFooter: !!snippet
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $qaY7H.AutomationDiscoveryMessage), {
        shouldUseAutomationDiscovery: shouldUseAutomationDiscovery
    }));
};
const $9c44b8c40f625697$export$89baf208493bc85a = ({ shouldUseAutomationDiscovery: shouldUseAutomationDiscovery, loading: loading, snippet: snippet, isEndOfPage: isEndOfPage = false, contentId: contentId, contentType: contentType, onLoadComplete: onLoadComplete })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { excerpt: excerpt } = (0, $gwFzn.useContext)((0, $AXitC.PageCardContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dDr80.PageCardContainer), {
        isHoverPageCard: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9CEYG.PageLink), {
        shouldHideFolder: true,
        featureAttributionCode: isEndOfPage ? (0, $71GjD.FeatureCode).EOP_REC_CARD : (0, $71GjD.FeatureCode).PAGE_TREE_CARD
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        padding: "space.200",
        xcss: $9c44b8c40f625697$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        alignBlock: "start",
        alignInline: "start",
        grow: "fill",
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        alignInline: "start",
        shouldWrap: false,
        grow: "fill",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $9c44b8c40f625697$var$headerIconStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aoeyL.ContentIcon), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        xcss: $9c44b8c40f625697$var$headerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $9c44b8c40f625697$var$titleStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $63k9q.Title), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eSkJX.Subtitle), null))), cloudId && (0, $9wGTI.fg)('use-aisnippets-platform-component') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $9c44b8c40f625697$var$aiSnippetStyles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $i5WUp.AISnippetWithRelayEnvironment), {
        contentId: contentId,
        contentType: contentType,
        cloudId: cloudId,
        source: isEndOfPage ? 'endOfPageRecommendations' : 'pageTree',
        onLoadComplete: onLoadComplete,
        fallbackText: excerpt
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $858989206fd37bb9$export$42f9a5b19b42c37e), {
        loading: !!loading,
        snippet: snippet,
        isEndOfPage: isEndOfPage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        spread: "space-between",
        shouldWrap: false,
        grow: "fill",
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $c9Olr.LastAction), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1R1bQ.SocialProof), {
        isInlineAction: true
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $qaY7H.AutomationDiscoveryMessage), {
        shouldUseAutomationDiscovery: shouldUseAutomationDiscovery
    }));
};

});

parcelRegister("eX37B", function(module, exports) {

$parcel$export(module.exports, "AISnippetCard", () => $51302722357824d9$export$a85413cf9e7fa814);
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $xQxzY = parcelRequire("xQxzY");

var $fYQcF = parcelRequire("fYQcF");

var $agEvB = parcelRequire("agEvB");

var $irVI7 = parcelRequire("irVI7");
var $1kHsc = parcelRequire("1kHsc");

var $7Sm4c = parcelRequire("7Sm4c");

var $6mKj3 = parcelRequire("6mKj3");

var $fd6g2 = parcelRequire("fd6g2");
var $lSOAM = parcelRequire("lSOAM");
const $9160a22955e67499$export$260ac0c0b5eaec2c = (0, $lSOAM.createCustomMetric)({
    key: (0, $fd6g2.AI_SNIPPET_HOVER_CARD_SEGMENT_KEY)
});



var $7opsJ = parcelRequire("7opsJ");
var $51302722357824d9$export$7b803b67517e1bfb = /*#__PURE__*/ function(SNIPPET_QUERY_ABORT_TYPE) {
    SNIPPET_QUERY_ABORT_TYPE["NOT_ENOUGH_CONTENT_ERROR"] = "NOT_ENOUGH_CONTENT_ERROR";
    SNIPPET_QUERY_ABORT_TYPE["NULL_RESPONSE"] = "NULL_RESPONSE";
    return SNIPPET_QUERY_ABORT_TYPE;
}({});
const $51302722357824d9$var$AISnippetCardAISnippetQuery = (0, $d2LG0.default)`query AISnippetCardAISnippetQuery($contentId:ID!$contentType:ConfluenceContentType!$objectType:KnowledgeGraphObjectType!){latestKnowledgeGraphObject(contentId:$contentId contentType:$contentType objectType:$objectType){contentId contentType objectData createdAt}}`;
const $51302722357824d9$var$EXPECTED_ERROR_TYPES = [
    (0, $agEvB.ErrorMessage).NOT_ENOUGH_CONTENT_ERROR,
    (0, $agEvB.ErrorMessage).BAD_REQUEST
];
const $51302722357824d9$export$a85413cf9e7fa814 = ({ contentId: contentId, children: children })=>{
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultError: trackAIResultError, trackAIResultView: trackAIResultView, trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $fYQcF.useAIEventsInstrumentation)();
    const objectType = (0, $7opsJ.KnowledgeGraphObjectType)[(0, $6mKj3.expVal)('consumption_ai_page_tree_snippets_2', 'type', 'snippet_v1')] || (0, $7opsJ.KnowledgeGraphObjectType).snippet_v1;
    const { loading: loading, data: data, error: error } = (0, $xQxzY.useQuery)($51302722357824d9$var$AISnippetCardAISnippetQuery, {
        variables: {
            contentId: contentId,
            contentType: (0, $7opsJ.ConfluenceContentType).PAGE,
            objectType: objectType
        }
    });
    const loadingRef = (0, $gwFzn.useRef)(loading);
    (0, $gwFzn.useEffect)(()=>{
        loadingRef.current = loading;
    }, [
        loading
    ]);
    (0, $gwFzn.useEffect)(()=>{
        trackAIInteractionInit();
        return ()=>{
            if (loadingRef.current) trackAIInteractionDismiss();
        };
    // Only on component mount/unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $gwFzn.useEffect)(()=>{
        if (loading) {
            experienceTracker.start({
                name: (0, $irVI7.AI_SNIPPET_EXPERIENCE),
                attributes: {
                    contentId: contentId
                }
            });
            (0, $9160a22955e67499$export$260ac0c0b5eaec2c).start();
        } else (0, $9160a22955e67499$export$260ac0c0b5eaec2c).stop();
    }, [
        contentId,
        experienceTracker,
        loading
    ]);
    const handleAbort = (0, $gwFzn.useCallback)((reason)=>{
        experienceTracker.abort({
            name: (0, $irVI7.AI_SNIPPET_EXPERIENCE),
            reason: reason
        });
    }, [
        experienceTracker
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!loading) {
            if (error) {
                const graphQLError = error.graphQLErrors[0]; // Will only be 1
                const aiErrorMessage = (0, $agEvB.ErrorMessage)[graphQLError.message] || (0, $agEvB.ErrorMessage).UNEXPECTED;
                trackAIResultError({
                    aiErrorMessage: aiErrorMessage,
                    aiErrorCode: graphQLError.extensions?.statusCode || 500
                });
                if ($51302722357824d9$var$EXPECTED_ERROR_TYPES.includes(aiErrorMessage)) handleAbort("NOT_ENOUGH_CONTENT_ERROR");
                else experienceTracker.fail({
                    name: (0, $irVI7.AI_SNIPPET_EXPERIENCE),
                    error: error
                });
                (0, $7Sm4c.markErrorAsHandled)(error);
            } else if (!data?.latestKnowledgeGraphObject) {
                handleAbort("NULL_RESPONSE");
                (0, $7Sm4c.markErrorAsHandled)(error); // `null` responses indicates expected error from the backend, so we can ignore those
            } else if (data?.latestKnowledgeGraphObject.objectData === ' ') {
                handleAbort("NOT_ENOUGH_CONTENT_ERROR");
                (0, $7Sm4c.markErrorAsHandled)(error); // if there is insufficient content to generate a snippet, then we should not have such errors alert our on-call
            } else {
                trackAIResultView({
                    doesNotMeetMAUCriteria: true
                });
                experienceTracker.succeed({
                    name: (0, $irVI7.AI_SNIPPET_EXPERIENCE)
                });
            }
        }
    }, [
        data,
        error,
        experienceTracker,
        handleAbort,
        loading,
        trackAIResultError,
        trackAIResultView
    ]);
    const snippet = (0, $gwFzn.useMemo)(()=>{
        const objectData = data?.latestKnowledgeGraphObject?.objectData;
        if (!objectData || objectData === ' ') return undefined;
        return objectData;
    }, [
        data
    ]);
    return children(loading, snippet);
};

});


//# sourceMappingURL=SpaceHoverPageCard.91ce248d.js.map
